export { AgmMap } from './directives/map';
export { AgmCircle } from './directives/circle';
export { AgmInfoWindow } from './directives/info-window';
export { AgmKmlLayer } from './directives/kml-layer';
export { AgmDataLayer } from './directives/data-layer';
export { AgmMarker } from './directives/marker';
export { AgmPolygon } from './directives/polygon';
export { AgmPolyline } from './directives/polyline';
export { AgmPolylinePoint } from './directives/polyline-point';
//# sourceMappingURL=directives.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@agm/core/directives.js
// module id = 492
// module chunks = 3